import { HttpErrorResponse } from "@angular/common/http";
import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DxDataGridComponent } from "devextreme-angular";
import CustomStore from "devextreme/data/custom_store";
import notify from "devextreme/ui/notify";
import { lastValueFrom } from "rxjs";
import { FileTransfersService, IOcbApiStringParameter, IOcbCUFileTransferRenamingParameter } from "../../core";

@Component({
    selector: 'app-file-transfer-renaming-parameters',
    templateUrl: './file-transfer-renaming-parameters.component.html',
    styleUrls: ['./file-transfer-renaming-parameters.component.scss'],
})
export class FileTransferRenamingParametersComponent implements AfterViewInit {
    @ViewChild('renamingParametersGrid', { static: true }) dataGrid?: DxDataGridComponent;
    
    protected dataSource: any;
    protected testData = {
        initial: ''
    } as ITestData;
    
    private fileTransferId: string;
    private maxRank: number = 0;
    private variable?: string;

    constructor(private fileTransfersService: FileTransfersService, private route: ActivatedRoute) { }

    ngAfterViewInit() {
        this.route.params.subscribe(_ => {
            if (this.route.snapshot.params.ft === 'new') return;
            this.fileTransferId = this.route.snapshot.params.ft;

            this.dataSource = new CustomStore({
                key: 'id',
                load: async () => {
                    const query$ = this.fileTransfersService.getRenamingParameters(this.fileTransferId);
                    const response = await lastValueFrom(query$);

                    this.maxRank = response.reduce((oa, u) => Math.max(oa, u.rank), 0);
                    
                    return {
                        data: response,
                        totalCount: response.length
                    };
                },
                insert: (value) => {
                    const parameter = {
                        parameter: value.parameter,
                        rank: value.rank
                    } as IOcbCUFileTransferRenamingParameter;

                    const query$ = this.fileTransfersService.addRenamingParameter(this.fileTransferId, parameter);
                    return lastValueFrom(query$);
                },
                update: (key, values) => {
                    const parameter = {
                        parameter: values.parameter,
                        rank: values.rank
                    } as IOcbCUFileTransferRenamingParameter;

                    const query$ = this.fileTransfersService.updateRenamingParameter(this.fileTransferId, key, parameter);
                    return lastValueFrom(query$);
                },
                remove: (key) => {
                    const query$ = this.fileTransfersService.deleteRenamingParameter(this.fileTransferId, key);
                    return lastValueFrom(query$);
                }
            });
            
        });
    }

    private handleError(error: any): void {
        let message: '';
        if (error instanceof HttpErrorResponse) {
            if (error.error.hasOwnProperty('message')) {
                message = error.error.message;
            } else if (error.error.hasOwnProperty('name')) {
                message = error.error.name;
            } else {
                message = error.error;
            }
        } else {
            message = error;
        }

        notify(message, 'error', 3000);
    }

    public newParameter(name) {
        this.variable = name;
        this.dataGrid?.instance.addRow();
    }

    public onAddButtonClick(e: any) {
        this.dataGrid?.instance.addRow();
        e?.event?.preventDefault();
    }
    
    public onNewRenamingParameter(e) {
        e.data.rank = this.maxRank + 1;
        if (this.variable) {
            e.data.parameter = this.variable;
            this.variable = undefined;
        }
    }

    public onRefreshButtonClick() {
        if (!this.dataGrid) return;
        this.dataGrid.instance.refresh();
    }

    public onRowUpdating(options) { options.newData = Object.assign(options.oldData, options.newData); }

    public testParameters(e) {
        this.testData.renamed = '';
        if (!this.testData.initial) return;
        
        const t = {
            value: this.testData.initial
        } as IOcbApiStringParameter;
        this.fileTransfersService.testRenamingParameters(this.fileTransferId, t).subscribe({
            next: (result) => this.testData.renamed = result,
            error: (error) => this.handleError(error)
        });
    }
}

export interface ITestData {
    initial: string;
    renamed?: string;
}